export const getEsmeList = (builder) => ({
    getEsmeList: builder.mutation({
      query: () => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/system_monitoring_esme',
          method: 'GET',
          params: { },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  